// Norwegian copy for a RateLimitError (utils/auth.js). Calm on purpose: the
// limits sit far above normal use, so a parent who meets one has done
// nothing wrong — just wait. ConversationView keeps its own send notice.

const LONG_WAIT = 'Prøv igjen om noen minutter.';
const GENERIC_LEAD = 'Litt for mange forespørsler på kort tid.';
const GENERIC_SHORT_WAIT = 'Vent et øyeblikk og prøv igjen.';

/**
 * @param {Error} err - the RateLimitError (or any error with status 429)
 * @param {object} [page] - page-specific copy for the page's own action
 * @param {string} [page.ownLimiter] - backend limiter name of that action
 * @param {string} [page.lead] - first sentence for that limiter
 * @param {string} [page.shortWait] - wait sentence when the wait is ≤ 60 s
 * @returns {string} the page copy when the 429 came from the page's own
 *   limiter (or an older backend that sends no name), else the generic
 *   fallback — a shared budget or the general tier is not about this action.
 *   Waits over 60 s always end with "Prøv igjen om noen minutter."
 */
export const rateLimitMessage = (err, { ownLimiter, lead, shortWait } = {}) => {
  const longWait = err?.retryAfterSeconds > 60;
  const pageCopy = Boolean(lead) && (!err?.limiter || err.limiter === ownLimiter);
  if (!pageCopy) return `${GENERIC_LEAD} ${longWait ? LONG_WAIT : GENERIC_SHORT_WAIT}`;
  return `${lead} ${longWait ? LONG_WAIT : (shortWait || GENERIC_SHORT_WAIT)}`;
};
